import type { ReactNode } from 'react';

import { ConvertMoneyProvider, TimezoneProvider } from '@gem-sdk/analytics';
import { useShopifyStore } from '~/modules/shopify/stores/shopify';
import { useShopTimezone } from '~/hooks/useShopTimezone';
import { useCurrencyStore } from '../stores';

import '@gem-sdk/analytics/style.css';

export interface IProps {
  children: ReactNode;
}

export const AnalyticsSdkProvider = ({ children }: IProps) => {
  const tz = useShopTimezone();
  const locale = useShopifyStore((state) => state.shopShopify?.primary_locale ?? '') || 'en-US';
  const currencyMode = useCurrencyStore((state) => state.currencyMode);

  return (
    <TimezoneProvider key={tz} tz={tz}>
      <ConvertMoneyProvider currency={currencyMode} locale={locale}>
        {children}
      </ConvertMoneyProvider>
    </TimezoneProvider>
  );
};
